import React from 'react';
import { FiUsers, FiCpu, FiMonitor } from 'react-icons/fi';
import Seo from '../components/Seo';
import { trackEvent } from '../analytics';
import { useUi } from '../context/UiContext';
import { t } from '../i18n';

const items = [
  {
    title: 'St. Louis GDG chapter',
    icon: <FiUsers />,
    desc: 'Local Google Developer Group fostering learning and collaboration.',
    href: 'https://gdg.community.dev/gdg-st-louis/'
  },
  {
    title: 'St. Louis Blockchain community',
    icon: <FiCpu />,
    desc: 'Meetups and projects at the intersection of cryptography and distributed systems.',
    href: 'https://www.meetup.com/blockchain-saint-louis-meetup-beginners-and-advanced'
  },
  {
    title: 'Paris VideoGame development community',
    icon: <FiMonitor />,
    desc: 'Indie and studio devs building playful, immersive experiences.',
    href: 'https://www.meetup.com/pvg-dev'
  }
];

export default function Community() {
  const { lang } = useUi();
  return (
    <section className="hero">
      <Seo title={t(lang, 'community.title') || 'Community'} description={t(lang, 'community.subtitle') || 'Communities we support and organize'} />
      <h1 className="hero-title">{t(lang, 'community.title') || 'Community'}</h1>
      <p className="hero-subtitle">{t(lang, 'community.subtitle') || 'Communities we support and organize'}</p>
      <div className="grid">
        {items.map((c) => (
          <a key={c.title} className="card" href={c.href} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }} onClick={() => trackEvent('community_click', { title: c.title })}>
            <div className="card-body" style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <div className="icon-btn" aria-hidden>{c.icon}</div>
              <div>
                <h3 className="card-title" style={{ marginBottom: 4 }}>{c.title}</h3>
                <p className="card-desc">{c.desc}</p>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}


